import { Box, Flex, Text } from '@chakra-ui/react';

import { LightningIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

const FLASH_SALE_EYEBROW_LABEL = 'FLASH SALE';
const DEFAULT_FLASH_SALE_EYEBROW_COLOR = '#AFC6FF';

export type FlashSaleEyebrowSize = 'default' | 'compact';

/**
 * Shared "FLASH SALE" eyebrow row (Figma 1672:3882 / 1672:3945): lightning icon + uppercase
 * condensed label + thin divider. Used by flash-sale homepage and catalog surfaces.
 */
export function FlashSaleEyebrow({
  color = DEFAULT_FLASH_SALE_EYEBROW_COLOR,
  size = 'default',
}: {
  color?: string;
  size?: FlashSaleEyebrowSize;
}) {
  const isCompact = size === 'compact';
  return (
    <Flex alignItems='center' gap={isCompact ? 2 : 4} width='100%'>
      <Flex alignItems='center' color={color} flexShrink={0} gap={2}>
        <LightningIcon height={isCompact ? '14px' : '16px'} width={isCompact ? '14px' : '16px'} />
        <Text
          fontFamily='condensed'
          fontSize={isCompact ? '12px' : '0.9375rem'}
          fontWeight='500'
          letterSpacing={isCompact ? '0.1em' : '0.06em'}
          lineHeight={1}
          textTransform='uppercase'
          whiteSpace='nowrap'
        >
          {FLASH_SALE_EYEBROW_LABEL}
        </Text>
      </Flex>
      <Box backgroundColor={color} flex={1} height='1px' minWidth={0} opacity={0.6} />
    </Flex>
  );
}
